import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-groupInfo-1",
  "use": "icon-groupInfo-1-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-groupInfo-1\">\n  <g id=\"icon-groupInfo-1_组_5474\" data-name=\"组 5474\" transform=\"translate(-1413 -417)\">\n    <path id=\"icon-groupInfo-1_路径_9187\" data-name=\"路径 9187\" d=\"M0,3.077H2.857V6.154H0ZM17.143,13.846H20v3.077H17.143ZM0,13.846H8.571v3.077H0ZM11.429,3.077H20V6.154H11.429V3.077Zm0,7.692h2.857V20H11.429V10.769ZM5.714,0H8.571V9.231H5.714Z\" transform=\"translate(1413 417)\" fill=\"#17efcc\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/groupInfo-1.svg
// module id = ZMap
// module chunks = 103